import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatRange } from './format';

/** Vertical timeline list shared by Experience and Education. */
function Timeline({ items, getTitle, getSubtitle }) {
    return (
        <Box
            sx={{
                position: 'relative',
                pl: 3,
                '&::before': { content: '""', position: 'absolute', left: 5, top: 6, bottom: 6, width: '1px', bgcolor: 'divider' },
            }}
        >
            {items.map((item) => {
                const range = formatRange(item.start_date, item.end_date);
                return (
                    <Box key={item.id} sx={{ position: 'relative', pb: 2.5, '&:last-child': { pb: 0 } }}>
                        <Box
                            sx={{
                                position: 'absolute',
                                left: -24,
                                top: 6,
                                width: 11,
                                height: 11,
                                borderRadius: '50%',
                                bgcolor: 'background.paper',
                                border: '2px solid',
                                borderColor: 'primary.main',
                            }}
                        />
                        <Typography variant="subtitle1" fontWeight={650} sx={{ lineHeight: 1.3 }}>
                            {getTitle(item)}
                        </Typography>
                        {getSubtitle(item) && (
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                                {getSubtitle(item)}
                            </Typography>
                        )}
                        {range && (
                            <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 0.25 }}>
                                {range}
                            </Typography>
                        )}
                        {item.description && (
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, whiteSpace: 'pre-wrap' }}>
                                {item.description}
                            </Typography>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
}

export default Timeline;
